<template>
  <el-table
    :data="consignments"
    style="width: 100%"
    stripe
  >
    <el-table-column
      label="Consignment"
      width="150px"
    >
      <template v-slot="{ row }">
        <slot
          name="con_full"
          :consignment="row"
        >
          <ConsignmentLink :consignment="row">
            {{ row.con_full }}
          </ConsignmentLink>
        </slot>
      </template>
    </el-table-column>

    <el-table-column
      label="From"
      prop="con_sender_name"
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      label="Reference"
      prop="con_ref"
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      label="Service"
      prop="service"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? cellValue.name : '-'"
    />

    <el-table-column
      label="Receiver"
      prop="con_receiver_name"
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      label="Suburb"
      prop="con_receiver_town"
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      label="Postcode"
      prop="con_receiver_postcode"
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      label="Items"
      prop="con_sum_items"
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      label="Weight"
      prop="con_sum_weight"
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue + 'kg' || '-') : '-'"
    />

    <el-table-column
      label="Cube"
      prop="con_sum_cube"
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue + 'm3' || '-') : '-'"
    />
  </el-table>
</template>

<script>
import ConsignmentLink from '@/components/Popovers/ConsignmentLink'

export default {
  components: {
    ConsignmentLink
  },
  props: {
    consignments: {
      type: Array,
      required: true
    }
  }
}
</script>
